import { NgxCurrencyDirective } from "ngx-currency";
import { LowercaseDirective } from "../directives/lower-case.directive";
import { PercentageMaskDirective } from "../directives/percentage-mask.directive";
import { TruncateTextDirective } from "../directives/truncate-text.directive";
import { UppercaseDirective } from "../directives/upper-case.directive";

export const SHARED_DIRECTIVES = [
    PercentageMaskDirective,
    TruncateTextDirective,
    UppercaseDirective,
    LowercaseDirective,
    NgxCurrencyDirective
];

export {
    PercentageMaskDirective,
    TruncateTextDirective,
    UppercaseDirective,
    LowercaseDirective,
    NgxCurrencyDirective
}
